import { Button, TextField, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { getRoles } from "../../../../api/role";
import { changeStatusUser, deleteUser, getUsers } from "../../../../api/user";
import { ROLES } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import FiltersCard from "../../../components/filters/Filter";
import Table, {
	buttonsStyle,
	substringFormatter,
} from "../../../components/tables/table";

const initialFilters = {
	roles: [],
};

export default function UsersPage() {
	const [data, setData] = useState([]);
	const [roles, setRoles] = useState([]);
	const [selectedUser, setSelectedUser] = useState(null);

	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);

	const [refresh, setRefresh] = useState(false);

	const [filteredData, setFilteredData] = useState([]);
	const [collapsed, setCollapsed] = useState(true);
	const [filterOptions, setFilterOptions] = useState(initialFilters);

	const history = useHistory();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function getData(users) {
		let data = [];
		for (let i = 0; i < users.length; ++i) {
			const user = users[i];

			if (user?.id !== loggedUser?.user_id) {
				const elem = {};

				elem.email = user?.email;
				elem.nombre = user?.nombre;
				elem.notas = user?.notas;
				elem.role = user?.role?.descripcion;
				elem.activo = user?.activo;
				elem.id = user?.id;

				data = data.concat(elem);
			}
		}
		return data;
	}

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() =>
							history.push("/usuarios/" + cell + "/edit")
						}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{loggedUser?.role?.rango === ROLES.SUPER_ADMIN && (
					<>
						<Tooltip
							title={elem?.activo ? "Desactivar" : "Activar"}
						>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setSelectedUser(elem);
									setOpenConfirmDialog(1);
								}}
							>
								{elem?.activo ? (
									<ToggleOffIcon />
								) : (
									<ToggleOnIcon style={{ color: "red" }} />
								)}
							</Button>
						</Tooltip>
						<Tooltip title="Eliminar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setSelectedUser(elem);
									setOpenConfirmDialog(2);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const columns = [
		{ dataField: "email", text: "Email", sort: true },
		{
			dataField: "nombre",
			text: "Nombre",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "notas",
			text: "Notas",
			headerAlign: "center",
			align: "center",
			formatter: substringFormatter,
		},
		{
			dataField: "role",
			text: "Rol",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getRoles(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					let roles = res.data;
					setRoles(roles);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se pudieron obtener los roles.",
				});
			});
		getUsers(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setFilteredData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se han podido obtener los usuarios.",
				});
			});
	}, [refresh]);

	const handleSearch = async () => {
		if (!data.length) return;
		setFilteredData(
			data.filter((item) => {
				let filter = true;
				if (filterOptions.roles)
					filter =
						filter &&
						filterOptions.roles
							?.map((x) => x.id)
							?.includes(item?.role?.id);
				if (filter) return item;
				return false;
			})
		);
	};

	const handleClearFilters = () => {
		setFilterOptions(initialFilters);
		setRefresh(true);
	};

	const renderFiltersContent = () => {
		return (
			<>
				<Autocomplete
					className="w-sm-50 w-100"
					multiple
					id="autocomplete-roles"
					filterSelectedOptions
					options={roles}
					getOptionLabel={(option) => option?.descripcion}
					value={filterOptions.roles || []}
					onChange={(event, selected) => {
						setFilterOptions({
							...filterOptions,
							roles: selected,
						});
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							margin="normal"
							variant="outlined"
							InputLabelProps={{
								shrink: true,
							}}
							label="Rol"
						/>
					)}
				/>
			</>
		);
	};

	return (
		<>
			<Card>
				<CardHeader headerClassName="px-0">
					<CardHeader
						title="Usuarios"
						sticky={false}
						headerClassName="d-flex justify-content-between w-100 py-3"
					>
						<CardHeaderToolbar>
							<button
								type="button"
								className="btn btn-primary"
								onClick={() => history.push("/usuarios/edit")}
							>
								Nuevo usuario
							</button>
						</CardHeaderToolbar>
					</CardHeader>
					<div className="w-100">
						<FiltersCard
							collapsable={false}
							filtersContent={renderFiltersContent}
							collapsed={collapsed}
							setCollapsed={setCollapsed}
							handleClearFilters={handleClearFilters}
							handleSearch={handleSearch}
						/>
					</div>
				</CardHeader>
				<CardBody>
					<Table data={getData(filteredData)} columns={columns} />

					<ConfirmDialog
						title={`¿Estás seguro de que quieres ${
							selectedUser?.activo ? "desactivar" : "activar"
						} este usuario?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusUser(
								selectedUser?.id,
								!selectedUser?.activo,
								loggedUser?.accessToken
							)
								.then((res) => {
									if (res.status === 204) {
										alertSuccess({
											title: `${
												selectedUser?.activo
													? "¡Desactivado!"
													: "¡Activado!"
											}`,
											customMessage: `Usuario ${
												selectedUser?.activo
													? "desactivado"
													: "activado"
											} con éxito`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: `No se ha podido ${
											selectedUser?.activo
												? "desactivar"
												: "activar"
										} el usuario.`,
									});
								});
						}}
					/>
					<ConfirmDialog
						title={
							"¿Estás seguro de que quieres eliminar este usuario?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteUser(
								selectedUser?.id,
								loggedUser?.accessToken
							)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "¡Eliminado!",
											customMessage:
												"Usuario eliminado con éxito.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"No se ha podido eliminar el usuario.",
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
